import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from './shared.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  user: any;
  employee: any;

  constructor(private router: Router, private service: SharedService)
  {

  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
    {
      this.user = localStorage.getItem('userInfo');
      this.user = JSON.parse(this.user);
      this.service.GetEmployeeByEmail(this.user.email).toPromise().then(data =>
      {
        this.employee = data[0];
        if (this.employee.isAdmin)
        {
          return true;
        }
        else
        {
          this.router.navigate(['/employee-view'])
          return false;
        }
      });
      return true;
    }

}
